// extracted by mini-css-extract-plugin
export default {"bold":"PzxlH4HwF6rKAinAh0Iv"};